import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation,useParams } from 'react-router-dom';
import API from '../utils/apiClient';
import './TransactionDetails.css';

const TransactionDetails = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [transaction, setTransaction] = useState(null);
  const { orderId } = useParams()
  // Get the orderId from the URL query parameters
  const params = new URLSearchParams(location.search);
  // const orderId = params.get('orderId');

  const email = useSelector((state) => state.email);
  const phoneNo = useSelector((state) => state.phoneNo);
  const name = useSelector((state) => state.name);

  // Move the check for orderId inside the effect to prevent hook call conditionally
  useEffect(() => {
    if (!orderId) {
      setError('Order ID is not available.');
      setLoading(false);
      return; // early return if orderId is not available
    }

    const fetchTransactionDetails = async () => {
      try {
        const result = await API.getPaymentStatus(orderId);
        
        if (!result.success) {
          throw new Error(result.error);
        }

        const data = result.data;
        console.log(data);

        if (data.results.results.status === "Success" && data.results && data.results.results) {
          const productNames = data.results.results.product_name;
          dispatch({
            type: 'ADD_SUBJECTS_TO_LIST',
            payload: productNames.split(', '),
          });
          await updateUserInfo(productNames.split(', '));

          setTransaction(data.results.results);
        } else {
          setError("No valid transaction details found.");
        }
      } catch (error) {
        setError("Error fetching data: " + error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactionDetails();
  }, [orderId, dispatch]);

  const updateUserInfo = async (productNames) => {
    try {
      const result = await API.updateUser({
        email: email,
        subjects: productNames,
      });

      if (!result.success) {
        throw new Error(result.error);
      }

      console.log('User info updated successfully:', result.data);
    } catch (error) {
      console.error('Failed to update user info:', error.message);
    }
  };

  if (loading) {
    return <div className="loading">Loading transaction details...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <div className="transaction-container">
      <h3>Transaction Details</h3>
      {transaction ? (
        <div className="transaction-details">
          <p><strong>Transaction ID:</strong> {transaction.txn_id}</p>
          <p><strong>Order ID:</strong> {transaction.order_id}</p>
          <p><strong>Merchant Name:</strong> {transaction.merchant_name}</p>
          <p><strong>Transaction Date:</strong> {transaction.txn_date}</p>
          <p><strong>Transaction Amount:</strong> {transaction.txn_amount}</p>
          <p><strong>Status:</strong> {transaction.status}</p>
          <p><strong>Product Name:</strong> {transaction.product_name}</p>
          <p><strong>Customer Name:</strong> {transaction.customer_name}</p>
          <p><strong>Customer Mobile:</strong> {transaction.customer_mobile}</p>
          <p><strong>Customer Email:</strong> {transaction.customer_email}</p>
        </div>
      ) : (
        <p>No transaction details available.</p>
      )}
    </div>
  );
};

export default TransactionDetails;
